import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { installPrompt } from './lib/pwa/installPrompt'
import { applyAdminAppHeadIfAdmin } from './lib/pwa/adminHead'

// ADMIN APP (2026-10-01). Chrome fires `beforeinstallprompt` once per page
// load, whenever its checks finish — keep it from the very start so the
// « Install the app » card can replay it. And on a direct /admin load, add the
// manifest + app tags now rather than when AdminLayout mounts (admin pages
// only — see lib/pwa/adminHead.ts for why not in index.html).
installPrompt.attach(window)
applyAdminAppHeadIfAdmin(document, window.location.pathname)

// STALE-TAB SELF-HEAL (2026-07-08): every deploy renames the hashed chunks, so
// a tab opened before a deploy 404s when it lazy-loads a route/module
// ("Failed to fetch dynamically imported module: …previewAssets-….js").
// Vite fires `vite:preloadError` on exactly that failure — reload once to pick
// up the fresh bundle instead of showing a dead red error. The sessionStorage
// guard (60s) prevents a reload loop if the network itself is down.
window.addEventListener('vite:preloadError', (event) => {
  const KEY = 'storiz_chunk_reload_at';
  const last = Number(sessionStorage.getItem(KEY) || 0);
  if (Date.now() - last < 60_000) return; // recently tried — let the error surface
  sessionStorage.setItem(KEY, String(Date.now()));
  event.preventDefault(); // swallow the import error — the reload supersedes it
  window.location.reload();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)

// CACHE-BUST MARKER — bump this string to force a NEW entry-chunk hash.
// Why this exists: `_redirects` sends any path with no matching file to
// index.html (200), and `_headers` stamps EVERYTHING under /assets/* with
// `max-age=31536000, immutable`. So if anything requests a freshly-built asset
// in the window before it has propagated, the edge caches that HTML fallback
// AS the .js file — for a year — and the app boots to a blank page
// ("Failed to fetch dynamically imported module"). The origin is fine; only
// that one URL is poisoned, so the cure is to make index.html (which is
// no-cache) point at a hash that was never poisoned.
// Poisoned so far: index-CHmTED3X.js (2026-07-16), index-DYS2OzSt.js (2026-07-25),
// index-CsSEx2GC.js (2026-07-28 — blank /admin/orders for the confirmation agent
// while every asset read clean from another PoP; poisoning is PER-EDGE, so a
// clean sweep from one location does NOT clear the others).
;(window as unknown as Record<string, unknown>).__STORIZ_BUILD = 'build-20260728-confirmcount';
